import type { MsalAuthenticationResult } from "@azure/msal-react";
import { Subtitle3 } from "@bms-ai/bms-ai-ui-lib/components";

const ErrorComponent = ({ error }: MsalAuthenticationResult) => {
  return (
    <div className="h-screen flex justify-center items-center p-8 text-center">
      <Subtitle3 strong>An Error Occurred: {error?.errorMessage}</Subtitle3>
    </div>
  );
};

export default ErrorComponent;
